// Pure helpers for the Avatar Builder's exports (kept out of the component so they can be tested).

/** Removes every class attribute (the on-screen Tailwind classes) and data-* attributes from SVG text. */
export function stripUiAttributes(svg: string): string {
  return svg
    .replace(/\s+class\s*=\s*("[^"]*"|'[^']*')/gi, "")
    .replace(/\s+data-[\w-]+\s*=\s*("[^"]*"|'[^']*')/gi, "");
}

/** Wraps everything inside the root <svg> in a circular clip. The size is the picture's viewBox (200). */
export function applyCircleClip(svg: string, viewBox = 200): string {
  const half = viewBox / 2;
  return svg
    .replace(/(<svg[^>]*>)/, `$1<clipPath id="avatar-circle"><circle cx="${half}" cy="${half}" r="${half}"/></clipPath><g clip-path="url(#avatar-circle)">`)
    .replace(/<\/svg>\s*$/, "</g></svg>");
}

/** Exported file text: UI classes stripped, optional circle clip. The trial badge is added afterwards, outside the clip. */
export function buildAvatarSvg(svg: string, opts: { circle: boolean }): string {
  const clean = stripUiAttributes(svg);
  return opts.circle ? applyCircleClip(clean) : clean;
}

/** One key per distinct download: the same picture in the same format, size and options. */
export function downloadSignature(parts: Record<string, string | number | boolean>): string {
  return Object.keys(parts).sort().map((k) => `${k}=${parts[k]}`).join("|");
}
